import useCurrentUser from '@/hooks/useCurrentUser';
import { computed } from '@nuxtjs/composition-api';

const { currentUser } = useCurrentUser();

const isAdmin = computed<boolean>(() => currentUser.value?.role === 'user');

export default isAdmin;
